import { render, staticRenderFns } from "./indexEvaluacion.vue?vue&type=template&id=3b137227&scoped=true&"
import script from "./indexEvaluacion.vue?vue&type=script&lang=js&"
export * from "./indexEvaluacion.vue?vue&type=script&lang=js&"
import style0 from "./indexEvaluacion.vue?vue&type=style&index=0&id=3b137227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b137227",
  null
  
)

export default component.exports